export default __webpack_public_path__ + "static/media/7.f4d20ed1.jpg";